import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";
import Breadcrumb from "@/components/base/Breadcrumb";

const timeline = [
  { year: "2021", title: "从兴趣出发", desc: "几个热爱娱乐八卦的编辑凑在一起，开始用业余时间整理每日娱乐热点。" },
  { year: "2023", title: "内容体系成型", desc: "正式确立明星、影视、网红、热点等八大内容分类，形成稳定的更新节奏。" },
  { year: "2025", title: "多端阅读体验", desc: "全面优化移动端阅读，推出收藏与分享功能，让好内容随时带在身边。" },
  { year: "2026", title: "持续进化中", desc: "引入更智能的内容聚合与推荐机制，让每一次打开都有新的发现。" },
];

const team = [
  { name: "周小瓜", role: "主编", icon: "ri-article-line", desc: "十年娱乐记者，擅长影视评论与行业观察。" },
  { name: "柴柴", role: "资深娱记", icon: "ri-camera-line", desc: "常年蹲守片场与活动现场，第一时间捕捉明星动态。" },
  { name: "潮流酱", role: "时尚编辑", icon: "ri-shirt-line", desc: "专注红毯造型与明星街拍，解读穿搭背后的故事。" },
  { name: "瓜田守夜人", role: "内容运营", icon: "ri-moon-line", desc: "负责热点追踪与内容把关，坚持理性吃瓜。" },
];

const values = [
  { icon: "ri-flashlight-line", title: "及时", desc: "热点事件第一时间跟进，不错过每一个精彩瞬间。" },
  { icon: "ri-emotion-happy-line", title: "有趣", desc: "用轻松好读的方式讲述娱乐故事，让吃瓜更快乐。" },
  { icon: "ri-shield-check-line", title: "理性", desc: "尊重事实与当事人隐私，倡导客观理性的讨论氛围。" },
];

export default function AboutPage() {
  usePageMeta({
    title: "关于我们 - 吃瓜网站",
    description:
      "了解吃瓜网站的发展历程、团队构成与内容理念。我们专注娱乐新闻与热点八卦，致力于提供及时、有趣、理性的娱乐资讯阅读体验。",
    keywords: "关于吃瓜网站,吃瓜网站团队,娱乐资讯平台,内容理念",
  });

  return (
    <div className="w-full">
      <div className="w-full px-4 md:px-6 pt-6">
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />
      </div>

      <section className="w-full px-4 md:px-6 py-8 md:py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center">
          <div>
            <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-semibold mb-3">
              <i className="ri-information-line" />
              关于我们
            </span>
            <h1 className="text-3xl md:text-4xl font-extrabold text-foreground-950 leading-tight">
              一个认真又不失趣味
              <br />
              的娱乐资讯<span className="text-primary-500">聚合平台</span>
            </h1>
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
              吃瓜网站诞生于几位娱乐爱好者的一个简单想法：让关注娱乐圈的人能够更轻松地获取信息。我们不追热点噱头，
              只希望把明星动态、影视评论、网红事件与热点话题，用清晰、好读、有温度的方式呈现给每一位读者。
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              从最初的每日资讯整理，到如今覆盖八大分类的内容体系，我们始终坚持内容为先、读者为本。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 px-5 h-11 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 whitespace-nowrap transition-colors"
              >
                联系我们
                <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/"
                className="inline-flex items-center gap-2 px-5 h-11 rounded-md border border-background-300 text-foreground-700 text-sm font-medium hover:bg-background-100 whitespace-nowrap transition-colors"
              >
                浏览资讯
              </Link>
            </div>
          </div>
          <div className="rounded-lg overflow-hidden h-64 md:h-80">
            <img
              src="https://readdy.ai/api/search-image?query=modern%20editorial%20workspace%20with%20warm%20orange%20accents%2C%20desks%20with%20screens%20and%20notes%2C%20cozy%20creative%20studio%20atmosphere%2C%20soft%20natural%20light%2C%20clean%20warm%20tones&width=1200&height=800&seq=chigua-about-hero&orientation=landscape"
              alt="吃瓜网站团队工作场景"
              title="吃瓜网站 - 关于我们"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950">内容理念</h2>
          <p className="mt-2 text-sm text-foreground-500">我们相信好内容应该兼具这三件事</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {values.map((v) => (
            <div key={v.title} className="rounded-lg bg-background-50 border border-background-200 p-6 text-center">
              <span className="w-14 h-14 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center mx-auto mb-4">
                <i className={`${v.icon} text-2xl`} />
              </span>
              <h3 className="text-lg font-bold text-foreground-900">{v.title}</h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950">发展历程</h2>
          <p className="mt-2 text-sm text-foreground-500">一路走来，感谢每一位瓜友的陪伴</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {timeline.map((t, i) => (
            <div key={t.year} className="relative rounded-lg border border-background-200 bg-background-50 p-6">
              <span
                className={`inline-flex items-center justify-center w-11 h-11 rounded-full text-background-50 font-bold mb-4 ${
                  i % 2 === 0 ? "bg-primary-500" : "bg-accent-500"
                }`}
              >
                {t.year.slice(2)}
              </span>
              <p className="text-xs text-foreground-400">{t.year}</p>
              <h3 className="mt-1 text-base font-bold text-foreground-900">{t.title}</h3>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-secondary-50 border-y border-secondary-200">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950">团队介绍</h2>
          <p className="mt-2 text-sm text-foreground-500">一群热爱娱乐的普通人</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {team.map((m) => (
            <div key={m.name} className="rounded-lg bg-background-50 border border-secondary-200 p-6 text-center">
              <span className="w-16 h-16 rounded-full bg-secondary-100 text-secondary-600 flex items-center justify-center mx-auto mb-4">
                <i className={`${m.icon} text-3xl`} />
              </span>
              <h3 className="text-base font-bold text-foreground-900">{m.name}</h3>
              <p className="text-xs text-primary-600 font-medium mt-1">{m.role}</p>
              <p className="mt-3 text-sm text-foreground-500 leading-relaxed">{m.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="rounded-lg bg-primary-500 px-6 md:px-12 py-10 md:py-14 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-background-50">想和我们聊聊？</h2>
            <p className="mt-2 text-sm md:text-base text-primary-50">
              无论是内容建议、合作洽谈还是反馈问题，都欢迎随时联系我们。
            </p>
          </div>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-6 h-12 rounded-md bg-background-50 text-primary-600 text-sm font-bold hover:bg-background-100 whitespace-nowrap transition-colors"
          >
            前往联系页面
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </section>
    </div>
  );
}